import React, {Component} from 'react';

import {Select, Spin, Form, Modal} from 'antd';

const FormItem = Form.Item;

export default class extends Component{
    constructor(props) {
        super(props);
    }

    onChange(data) {
        this.props.onChange(data || {});
    }

    onFocus() {
        if(this.props.onFocus) {
            this.props.onFocus(this.refs.select);
        }
    }

    onSearch(value) {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        this.currentValue = value;

        this.timeout = setTimeout(() => {
            if(typeof this.props.onSearch === 'function') {
                this.props.onSearch(value);
            }
        }, 300);
    }

    render() {
        const { getFieldDecorator, label, placeholder, disabled, name, data, style, mode, zgcpEnter, value } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        return (
            <FormItem label={label} {...zgcpEnter?formItemLayout:''}>
                {
                    getFieldDecorator ? (
                        getFieldDecorator(name, {
                            initialValue: value,
                            rules: [{
                                required: true,
                                message: '请选择'+ label,
                            }],
                        })(
                            <Select
                            mode="multiple"
                            disabled={disabled}
                            style={style || {width: 240}}
                            labelInValue
                            placeholder={placeholder || "请选择对比教师..."}
                            allowClear={true}
                            showSearch={true}
                            onSearch={this.onSearch.bind(this)}
                            filterOption={false}
                            onFocus={this.onFocus.bind(this)}
                            dropdownMatchSelectWidth={false}
                            onChange={(value) => {
                                this.onChange(value);
                            }}>
                            {
                                data.map((d, index) => (
                                    <Option key={index.toString()} value={d.value}>{d.label}</Option>
                                ))
                            }
                            </Select>
                        )
                    ) :  (
                        <Select
                            mode="multiple"
                            ref="select"
                            disabled={disabled}
                            style={style || {width: 240}}
                            labelInValue
                            value={value}
                            dropdownMatchSelectWidth={false}
                            placeholder={placeholder || "请选择对比教师..."}
                            allowClear={true}
                            showSearch={true}
                            onSearch={this.onSearch.bind(this)}
                            filterOption={false}
                            onFocus={this.onFocus.bind(this)}
                            onChange={(value) => {
                                this.onChange(value);
                            }}>
                            {
                                data.map((d, index) => (
                                    <Option key={d.key.toString()} value={d.value}>{d.label}</Option>
                                ))
                            }
                        </Select>
                    )
                }
            </FormItem>
        )
    }
}